import countries from '@/lib/countries'

const countriesData = countries.map((country) => ({
    value: country.isoCode,
    label: country.name,
}))

// Mantine
import { Select } from '@mantine/core'

export default function CountrySelect({ ...props }) {
    return <Select data={countriesData} {...props} />
}
